export default {

  SET_DPR_SIGNATURES: (state, payload) => state.dprSignatures = payload

}